var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2.182c-3.863 0-7 3.137-7 7 0 3.864 3.137 7 7 7s7-3.136 7-7c0-3.863-3.137-7-7-7zm0 2c2.76 0 5 2.241 5 5 0 2.76-2.24 5-5 5s-5-2.24-5-5c0-2.759 2.24-5 5-5z",
    fill: "#ffffff",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.821,
    cy: 24.182,
    r: 1,
    fill: "#ffffff",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.821,
    cy: 29.182,
    r: 1,
    fill: "#ffffff",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.821,
    cy: 19.182,
    r: 1,
    fill: "#ffffff",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.306 20.182h5.91a1 1 0 0 0 0-2h-5.91a1 1 0 0 0 0 2zM20.306 25.182h5.91a1 1 0 0 0 0-2h-5.91a1 1 0 0 0 0 2zM20.306 30.182h5.91a1 1 0 0 0 0-2h-5.91a1 1 0 0 0 0 2zM3.722 28.091H16a1 1 0 0 1 0 2H2.722a1 1 0 0 1-1-1v-2a9 9 0 0 1 9-9H16a1 1 0 0 1 0 2h-5.278a7 7 0 0 0-7 7z",
    fill: "#ffffff",
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserList);
export default __webpack_public_path__ + "static/media/user-list.5ea697be01a2c204b4ac198b5d08fd55.svg";
export { ForwardRef as ReactComponent };